import { ArticleExtraData } from "../../../../../../articlePage/stateInterfaces";
import { NewsFlashSpecialSlotItem } from "./newsFlashSpecialSlotItem";

interface NewsFlashSpecialMobileSlotListProps {
    isLTR: boolean
    domain: string
    languageCode: string
    tickerArticles: ArticleExtraData[]
    isFirstInterval: boolean
    tickerBottomLink: string
    roofOngoingEvent: boolean
    tickerBottomTitle: string
    shouldDisplayLoader: boolean
    shouldDisplayTicker: boolean
    highlightingDuration: number
}

export class NewsFlashSpecialMobileSlotList extends React.Component<NewsFlashSpecialMobileSlotListProps, {}> {

    public render() {

        const { tickerArticles, isFirstInterval, languageCode, tickerBottomLink, shouldDisplayLoader, tickerBottomTitle, shouldDisplayTicker, highlightingDuration, isLTR, domain, roofOngoingEvent } = this.props;
        const tickerLoaderClass = `newTickerLoader ${shouldDisplayLoader ? "" : "none"}`;
        const classNames = `news-flash-special-mobile-slot-list-wrapper ${shouldDisplayTicker ? "" : "none"}`;

        return (
            <div className={classNames}>
                <img className={tickerLoaderClass} src={"https://www.ynet.co.il/images/NewsFlash/news-flashes-bell.gif"} />

                <div className="news-flash-special-mobile-slot-list">
                    {tickerArticles.map((article, index) => {
                        const previousRoof = index > 0 ? tickerArticles[index - 1].roof : null;
                        const nextRoof = index < tickerArticles.length - 1 ? tickerArticles[index + 1].roof : null;

                        return (
                            <NewsFlashSpecialSlotItem
                                isLTR={isLTR}
                                domain={domain}
                                article={article}
                                isMobileWeb={true}
                                nextRoof={nextRoof}
                                key={article.articleId}
                                previousRoof={previousRoof}
                                languageCode={languageCode}
                                isFirstInterval={isFirstInterval}
                                roofOngoingEvent={roofOngoingEvent}
                                highlightingDuration={highlightingDuration}
                            />
                        )
                    })}
                </div>

                <a href={tickerBottomLink} className="bottomLink" id="ticker-bottom-link">
                    <span className=" bottomLinkTitle">{tickerBottomTitle}</span>

                    {/* <div className="all-flashes-count">{tickerArticles.length}</div> */}

                    <div className="bottomLinkIcon" />
                </a>
            </div>
        )
    }
}